<template>
    <div id="quiz-students">
      <template v-if="!quizHasStarted">
        <h3 class="my-base">حدد طلبة كل مجموعة</h3>
        <p class="leading-loose">يمكنك توزيع الطلبة بــ </p>
        <ul class="mb-base list">
          <li class="list__item items-center">
            <feather-icon icon="ChevronsLeftIcon" class="w-5 h-5 ml-1"/>
            <span>توزيع الطلبة عشوائية عن طريق الضغط علي زر توزيع الطلبة عشوائياً</span>
          </li>
          <li class="list__item">
            <feather-icon icon="ChevronsLeftIcon" class="w-5 h-5 ml-1"/>
            <span>الضغط علي زر التحويل الذي بجانب كل طالب</span>
          </li>
          <li class="list__item">
            <feather-icon icon="ChevronsLeftIcon" class="w-5 h-5 ml-1"/>
            <span>السحب والإفلات في مربع المجموعة</span>
          </li>
        </ul>
      </template>
      <div id="quizStudents" class="vx-row mt-4">
        <div v-if="!quizHasStarted" class="vx-col xl:w-1/3 md:w-1/2 w-full mb-base">
          <vx-card title="جميع الطلبة" no-shadow card-border>
            <div slot="actions">
              <vs-button @click="randomize"> توزيع الطلبة عشوائياً</vs-button>
            </div>
            <vs-list>
              <VuePerfectScrollbar class="students-list-scroll-area" :settings="settings">

                <draggable :list="students" group="people" class="p-2">
                  <vs-list-item v-for="(student, index) in students" :key="index" :title="student.full_name" :subtitle="`${student.id.toString()} (${student.course_group})`"
                                class="cursor-grab" >
                    <vs-avatar slot="avatar" :src="student.image" />

                    <vs-dropdown class="p-2 cursor-pointer" vs-custom-content vs-trigger-click>
                      <vs-button class="btn-drop" icon="icon-repeat" icon-pack="feather"></vs-button>
                      <vs-dropdown-menu>
                        <template v-for="(convertGroup, convertIndex) in quizGroups.length">
                          <vs-dropdown-item :key="convertIndex" @click="convertTo(students, quizGroups[convertIndex].students, index)">
                            <span>{{`إلى المجموعة ${convertIndex + 1}`}}</span>
                          </vs-dropdown-item>
                        </template>
                      </vs-dropdown-menu>
                    </vs-dropdown>

                  </vs-list-item>
                </draggable>

              </VuePerfectScrollbar>
            </vs-list>
          </vx-card>
        </div>
        <div :class="['vx-col w-full', {'xl:w-2/3 md:w-1/2 ': !quizHasStarted}]" >
          <div class="vx-row">
            <div :class="['vx-col w-full mb-base xl:w-1/2', {'xl:w-1/3': quizHasStarted}]" v-for="(group, groupIndex) in quizGroups" :key="groupIndex">
              <vx-card :title="`طلبة النموذج ${String.fromCharCode(groupIndex + 65)}`" no-shadow card-border collapse-action>
                <vs-list>
                  <VuePerfectScrollbar class="students-list-scroll-area" :settings="settings">

                  <draggable :disabled="quizHasStarted" :list="group.students" group="people" class="p-2">
                    <template v-if="group.students.length > 0">
                      <vs-list-item v-for="(student, index) in group.students" :key="index" :title="student.full_name" :subtitle="`${student.id.toString()} (${student.course_group})`"
                                    :class="{'cursor-grab': !quizHasStarted}">
                        <vs-avatar slot="avatar" :text="`${index+1}`"/>

                        <vs-dropdown v-if="!quizHasStarted" class="cursor-pointer" vs-custom-content vs-trigger-click>
                          <vs-button class="btn-drop" icon="icon-repeat" icon-pack="feather"></vs-button>
                          <vs-dropdown-menu>
                            <template v-for="(convertGroup, convertIndex) in quizGroups.length">
                              <vs-dropdown-item v-if="groupIndex !== convertIndex" :key="convertIndex"
                                                @click="convertTo(group.students, quizGroups[convertIndex].students, index)">
                                <span>{{`إلى المجموعة ${convertIndex + 1}`}}</span>
                              </vs-dropdown-item>
                            </template>
                            <vs-dropdown-item @click="convertTo(group.students, students, index)">
                              <span>إلى جميع الطلبة</span>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>

                      </vs-list-item>
                    </template>
                    <div v-else class="flex flex-col items-center">
                      <feather-icon icon="UserPlusIcon" class="mb-4 p-8 shadow-md rounded-full" svgClasses="w-16 h-16" />
                      <h4 class="py-2 px-4 shadow-md rounded-full">
                        <span>هذه المجموعة خالية، قم بإضافة الطلبة إليها</span>
                      </h4>
                    </div>
                  </draggable>

                  </VuePerfectScrollbar>
                </vs-list>
              </vx-card>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!quizHasStarted" class="flex justify-end">
        <vs-button @click="saveQuizStudents" class="w-32">حفظ</vs-button>
      </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import { VueContext } from 'vue-context';
    import quizzesAPI from '@/api/quizzesAPI'

    export default {
        name: "QuizStudents.vue",
        components: {
            draggable,
            VuePerfectScrollbar,
            VueContext
        },
        props: {
            quizGroups: {
                type: Array,
                default: () => []
            },
            students: {
                type: Array,
                default: () => []
            },
            quizHasStarted: {
                type: Boolean,
                default: false
            },
            settings: {
                maxScrollbarLength: 80,
                wheelPropagation: true,
            },
        },
        data() {
            return {
                quizGroupStudents: []
            }
        },
        methods: {
            convertTo(from, to, index){
                let student = from[index]
                to.push(student)
                this.$delete(from, index)
            },
            randomize(){
                let groupIndex = 0;

                this.quizGroups.forEach(group => {
                    group.students.forEach(student => this.students.push(student))
                    group.students = []
                })

                while(this.students.length > 0){
                    let randomIndex = Math.floor(Math.random() * this.students.length)
                    this.quizGroups[groupIndex].students.push(this.students[randomIndex])
                    this.$delete(this.students, randomIndex)
                    groupIndex < (this.quizGroups.length - 1) ? groupIndex++ : groupIndex = 0
                }
            },
            saveQuizStudents(){
                this.$startLoading()
                let quizStudentsGroups = this.quizGroups.map(group => {
                    return { quiz_id: group.quiz_id, group: group.group, students: group.students }
                })

                quizzesAPI.saveStudentsQuiz(this.$route.params.quiz_id, {'quiz_groups' : quizStudentsGroups})
                    .then(() => this.$notifySuccess('يمكنك من إعادة توزيع الطلبة أو الغاء طالب من اي مجموعة.', 'لقد تم توزيع الطلبة بنجاح'))
                    .finally(() => this.$closeLoading())
            },

        },
    }
</script>

<style lang="scss">
  #quizStudents {
    .students-list-scroll-area{
      position: relative;
      margin: auto;
      width: 100%;
      max-height: 50vh;
    }
  }
</style>
